import React from 'react';
import { Typography, List, Container, Paper } from '@mui/material';
import ChipListItem from '../art/ChipListItem';

const FixtureGenerationRules = () => {
    return(
        <Paper>
            <Container>
                <Typography variant="h4">Fixture generation rules</Typography>
                <List>
                    <ChipListItem>
                        The hosts for the last N (where N is the number of players) games of the season are randomly drawn from all players
                    </ChipListItem>
                    <ChipListItem>
                        The hosts for the remaining (9-N) games are randomly drawn from a group of players who hosted the fewest number of games the previous season.
                        If there are too few players in that group, then the group will be expanded to include players who hosted the next fewest games
                    </ChipListItem>
                </List>
            </Container>
        </Paper>
    );
}

export default FixtureGenerationRules;